import callAPiBase from './base';

const stopsApi = {
  get: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/stopList',
      method: 'GET',
      useToken: true,
      title: 'Stop - Get List',
      params,
    }),
  getItineraryStops: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/itineraryStopList',
      method: 'GET',
      useToken: true,
      title: 'Stop - Get List',
      params,
    }),
  getReports: ({ params }: { params?: object }) =>
    callAPiBase({
      endpoint: '/stopReports',
      method: 'GET',
      useToken: true,
      title: 'stopReports - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/stopCreate',
      method: 'POST',
      useToken: true,
      title: 'Stop - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/stopUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Stop - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/stopDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Stop - Delete',
      params,
    }),
};

export { stopsApi };
export default stopsApi;
